import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Custom Components
import Loader from "../../../components/Loader";
import Header from "./Header";
import spamCheckTableSchema from "./spamCheckTableSchema";
import { toastr } from "react-redux-toastr";
import { getSpamCheck, deleteSpamCheck } from "../../../state/actions/adminActions";
import { Container, Card, CardBody, Alert } from "reactstrap";
import { isZeroLengthString } from "../../../utils/normalize";

const SpamCheck = ({ errors, loading, spamCheckResult, getSpamCheck, deleteSpamCheck }) => {
  const [searchText, setSearchText] = useState(null);
  const [screenMode, setScreenMode] = useState(null);

  const onSearchTextChange = ({ target }) => {
    setSearchText(target.value);
    setScreenMode("");
  };

  const onSearchClick = () => {
    console.log(`Calling spam check ${searchText}`);
    let valid_email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(searchText);
    if (isZeroLengthString(searchText) || !valid_email) {
      return toastr.error("Please enter valid Email Address");
    }
    setScreenMode("search");
    getSpamCheck(searchText);
  };

  const onDeleteClick = (spamRecord) => {
    toastr.confirm(`Are you sure to remove email  ${spamRecord.email} from spam check?`, {
      okText: "Delete Record",
      onCancel: () => console.log(`cancelled operation`),
      onOk: () => {
        deleteSpamCheck(spamRecord.email);
        setScreenMode("delete");
      },
    });
  };

  const LoaderSection = () => {
    return loading && <Loader />;
  };

  const ScreenModeChange = () => {
    let text = "";
    if (
      !loading &&
      "search".localeCompare(screenMode) === 0 &&
      (!spamCheckResult || spamCheckResult.length === 0)
    ) {
      text = "Email not found in spam";
      toastr.error("Email not found in spam");
    }

    if (text) {
      return (
        <Alert color="warning" className="alert-outline">
          <div
            className="alert-message"
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          >
            <h4 className="alert-heading">{text}</h4>
          </div>
        </Alert>
      );
    }
    return null;
  };

  return (
    <Container fluid className="p-0">
      <Header
        searchText={searchText}
        onSearchTextChange={onSearchTextChange}
        onSearchClick={onSearchClick}
        loading={loading}
      />
      <Card>
        <CardBody>
          <p>- You can search an email address and it will display if it is flagged for spam</p>
          <p>
            - The Email then can be removed from the spam list by clicking the "trash icon" icon to
            the right
          </p>
          <Alert color="warning" className="alert-outline">
            <div className="alert-icon">
              <FontAwesomeIcon icon={faBell} size="lg" className="align-middle" />
            </div>

            <div
              className="alert-message"
              style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            >
              <h4 className="alert-heading">Reminder</h4>
              Reminder to inform customer to remove the spam designation from their email as well.
            </div>
          </Alert>
        </CardBody>
        <CardBody>
          <ScreenModeChange />
          <LoaderSection />
        </CardBody>
        <CardBody>
          <BootstrapTable
            bootstrap4
            hover
            classes="table-responsive-md"
            keyField="_id"
            data={spamCheckResult || []}
            columns={spamCheckTableSchema({ onDeleteClick })}
            bordered={false}
          />
        </CardBody>
      </Card>
    </Container>
  );
};

SpamCheck.propTypes = {
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  spamCheckResult: PropTypes.array.isRequired,
  getSpamCheck: PropTypes.func.isRequired,
  deleteSpamCheck: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors["spamCheck"],
  loading: state.admin.loading.spamCheckResult,
  spamCheckResult: state.admin.spamCheckResult,
});

export default connect(mapStateToProps, {
  getSpamCheck,
  deleteSpamCheck,
})(SpamCheck);
